import * as React from 'react';
import { formatWithTimeZoneName } from 'owa-timezone';
import { FullOptionsLink } from 'owa-options-link';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';

const styles = require('./AgendaMailFull.scss');

@observer
export default class TimeZone extends React.Component<{}, {}> {
    render() {
        return (
            <div className={styles.settingsContainer}>
                <span className={styles.settingsDescription}>
                    {formatWithTimeZoneName(strings.options_current_TimezoneLabel)}
                </span>
                <FullOptionsLink category="general" subcategory="timeAndLanguage">
                    {strings.options_update_TimezoneLinkText}
                </FullOptionsLink>
            </div>
        );
    }
}
